import {Injectable} from '@angular/core';
import {ApiService} from "../../api/api.service";
import {getApi} from "../../api/fn/operations/get-api";
import {catchError, map, tap} from "rxjs/operators";
import {firstValueFrom, Observable, of} from "rxjs";
import {postApiLogin} from "../../api/fn/operations/post-api-login";
import {apiLogoutGet} from "../../api/fn/operations/api-logout-get";
import {User2} from "../../api/models/user-2";
import {postSsoLogin} from "../../api/fn/operations/post-sso-login";

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private isAuthenticated: boolean = false;
  private user: User2|null = null;
  private expiry: Date|null = null;
  constructor(
    private apiService: ApiService,
  ) {
  }

  checkExpiration(){
    if(this.expiry && new Date() > this.expiry){
      this.logout()
      return false;
    }
    return true;
  }

  isLoggedIn(): Observable<boolean>|boolean {
    this.checkExpiration();
    if(!this.isAuthenticated){
      return this.setUser()
    }
    return true
  }

  logout(){
    const logoutRequest = this.apiService.invoke(apiLogoutGet);
    this.isAuthenticated = false;
    this.user = null;
    this.expiry = null;
    return firstValueFrom(logoutRequest)
  }

  setUser(){
    const user = this.apiService.invoke(getApi).pipe(catchError(() => {
      return of(null)
    }));
    user.subscribe((value: User2|null) =>{
      if(value !== null) {
        this.setUserData(value);
      }
    })

    return user.pipe(map(data => !!data));
  }

  doLogin(username: string, password: string, remeberMe: boolean = false){
    const request$ = this.apiService.invoke(postApiLogin, {"body": {"username" : username, "password": password, _remember_me : remeberMe}});

    request$.pipe(tap( result => {
        if (result) {
          this.setUserData(result);
        }
      })
    );

    return request$;
  }

  doSsoLogin(code: string){
    const request$ = this.apiService.invoke(postSsoLogin, {"code" : code});

    request$.pipe(tap( result => {
        if (result) {
          this.setUserData(result);
        }
      })
    );


    return request$;
  }

  private setUserData(result: User2){
    this.isAuthenticated = true;
    this.user = result;
    this.expiry = new Date(new Date().getTime() + 30 * 24 * 60 * 60 * 1000);
  }

  getAuth(){
    this.checkExpiration();
    return this.user;
  }


  isGranted(role: string){
    return this.getAuth()?.roles?.includes(role) ?? false;
  }

}
